class PlaySounds {
  constructor() {
    this.tracks = {};
  }

  play(name, repeat) {
    return new Promise(resolve => {
      if (this.audio) {
        this.audio.pause();
        this.audio.currentTime = 0;
        this.audio = null;
      }
      if (!this.tracks[name]) {
        this.tracks[name] = require(`../../static/sounds/${name}.mp3`);
      }
      this.audio = new Audio(this.tracks[name]);
      this.audio.play();
      this.audio.onended = () => {
        if (repeat && this.audio) {
          this.audio.currentTime = 0;
          this.audio.play();
        }
        resolve();
      };
    });
  }
}

export default PlaySounds;



// WEBPACK FOOTER //
// ./src/services/play-sounds.service.js